import { FunctionComponent, useEffect, useRef, useState } from "react"

import { motion } from "framer-motion"

import video from "@fuse/assets/video/vid-video-loader.mp4"

// import "./style.css"

const VideoLoader: FunctionComponent<{
  loading: boolean
  setShowLoader: (show: boolean) => void
}> = ({ loading, setShowLoader }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [fadeOut, setFadeOut] = useState(false)

  const handleVideoEnd = () => {
    if (loading) {
      if (!videoRef.current) return
      videoRef.current.muted = true
      videoRef.current!.currentTime = 0 // Restart video
      videoRef.current!.play().catch((err) => {
        console.error("Video playback failed:", err)
      })
    } else {
      setFadeOut(true) // Start fade-out animation
      setTimeout(() => setShowLoader(false), 500) // Remove after fade-out
    }
  }

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: fadeOut ? 0 : 1 }}
      transition={{ duration: 0.5 }}
      className="bg-black z-30 fixed inset-0 max-h-screen w-screen flex items-center justify-center !overflow-hidden"
    >
      <div className="w-[80vw] h-auto max-w-[300px] max-h-[200px] flex justify-center">
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnd}
          className="w-full h-auto"
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </motion.div>
  )
}

export default VideoLoader
